export const routingTransitionConfig = {
  from: { opacity: 0, },
  enter: { opacity: 1, delay: 300 },
  leave: { opacity: 0, position: 'absolute', width: '100%' },
  initial: { opacity: 0 },
  update: { position: 'absolute', width: '100%' },
  config: { mass: 0.1, tension: 1000, friction: 100 }
}